import React from 'react'

import { Grid, ButtonBase, Typography, makeStyles } from '@material-ui/core'
import { LocationOn } from '@material-ui/icons'

import { useLiterals } from '~/components/Literals'
import { usePositionHandler } from '~/containers/PositionHandler'
import track from '~/track'

const useStyle = makeStyles((theme) => ({
  customerLocationBar: {
    display: 'flex',
    alignItems: 'center',
    height: 35,
    background: '#EEEBEB20',
    paddingLeft: '16px',
    fontSize: '16px'
  },
  textLocation: {
    display: 'flex',
    alignItems: 'center'
  },
  iconColor: {
    color: theme.palette.primary.main
  }
}))

function PositionLabel({ position }) {
  let address = null

  if (Object.values(position?.user || {}).some(Boolean)) {
    const { street, city, state, description } = position.user

    address =
      description || `${street?.concat(', ') || ''} ${city?.concat(' - ') || ''}${state || ''}`
  } else {
    address = <span>informe seu local manualmente</span>
  }

  return address || <span style={{ display: 'none' }} />
}

const PositionButton = () => {
  const classes = useStyle()
  const { getLiteral } = useLiterals()

  const position = usePositionHandler()

  const handleChangeLocation = () => {
    position.handlerShowPositionDialog(true)
    track('alterarLocalização', {
      category: 'menu',
      name: `${position.user?.city} - ${position.user?.state}`
    })
  }

  return (
    <Grid id="user-position-location" className={classes.customerLocationBar}>
      <Typography
        noWrap
        data-cy="current-city"
        component={ButtonBase}
        className={classes.textLocation}
        onClick={handleChangeLocation}
      >
        {position.user && <span>{getLiteral('2398')}:</span>}
        <LocationOn
          className={classes.iconColor}
          style={{
            fontSize: '16px',
            margin: '0 5px'
          }}
        />
        <span
          style={{
            textDecoration: 'underline',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
          datalayer_location_state={
            position?.user?.state?.length > 2 ? position.user?.stateCode : position?.user?.state
          }
          datalayer_location_city={position?.user?.city}
        >
          <PositionLabel position={position} />
        </span>
      </Typography>
    </Grid>
  )
}

export default PositionButton
